import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV192({ createThumbnail }) {
  return (
    <ReleaseCard version="v1.9.2" date="14th April 2026" title="Are you ready for the chop?!">
      <div className="mb-6">
        <h5 className="text-lg font-medium text-purple-400 mb-2">Introducing the amazing new Pot Chop Calculator! 🎉</h5>
        <p className="text-gray-300 mb-3">
          Big new feature: Advanced chop calculator with ICM, Chip Chop, Even Split, and a smart Deal Negotiator—plus ‘leave money to play for’ support for real-world tournament deals.
        </p>
        <p className="text-gray-300 mb-3">
          Payout deals are now published to all game viewers on the main game screen.
        </p>
        <p className="text-gray-300 mb-3">
          Improved main screen icons for a cleaner, more modern look.
        </p>
        <p className="text-gray-300 mb-3">
          Minor bug fixes and performance enhancements to make the app faster and more stable.
        </p>
        <div className="mt-4 flex flex-wrap gap-4">
          {createThumbnail('/v1.9.2/splitOnMainScreen.png', 'Pot split shown on main screen')}
          {createThumbnail('/v1.9.2/defineThePot.png', 'Define the pot')}
          {createThumbnail('/v1.9.2/payoutLockedIn.png', 'Payout locked in')}
          {createThumbnail('/v1.9.2/chopCalculator.png', 'Chop calculator feature preview')}
          {createThumbnail('/v1.9.2/chopSelector.png', 'Chop selector feature preview')}
          {createThumbnail('/v1.9.2/chopSelector2.png', 'Chop selectors feature preview')}
        </div>
      </div>
    </ReleaseCard>
  );
}
